module.exports = __webpack_public_path__ + "static/media/message-finished.91120199.svg";